
import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { JkfieldlabelComponent } from '../../components/jkfieldlabel/jkfieldlabel.component';
import { jkLib } from '../../services/jkCommon';
import { idNameItem } from '../../services/jkInterface';
import { JkBaseComponent } from '../jkbase/jkbase.component';

let radioStyles = `.example-radio-group {
    display: flex;
    flex-direction: column;
    margin: 15px 0;
    align-items: flex-start;
  }

  .example-radio-button {
    margin: 5px;
  }`;

@Component({
  selector: 'app-jkradiogroup',
  standalone: true,
  imports: [MaterialModule, FormsModule, JkfieldlabelComponent],
  templateUrl: './jkradiogroup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [radioStyles],
  //styleUrl: './jkradiogroup.component.css'
})
export class JkradiogroupComponent extends JkBaseComponent implements OnInit {
  override comType: string = 'jkradiogroup';
  override flexStyle:any = { display: 'flex'};
  public readonly items = input<idNameItem[]>([]);
  _value: string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()  set value(value:string){
    this._value = value;
    if(this.valueChange)
      this.valueChange.emit(this._value);
  }
  get value(){
    return this._value;
  }
  /*
  get itemIndex(): number{
    return this.items.findIndex(item => item.id === this._value);
  }
  set itemIndex(value: number){
    if(value >= 0 && value < this.items.length)
      this._value = this.items[value].id;
    else
      this._value = '';
  }
  _valueN: number = 0;
  @Input()
  set valueN(value:number){// 有在用 不要再刪
    this._valueN = value; // = jkLib.fixString(value);
    if(this._valueN === null || this._valueN === undefined)
      this._value = '';
    else
      this._value = this._valueN.toString();
  }
      */
  /*get selectedItem(): idNameItem{
    if(this.itemIndex < 0)
      return {id:'',name:''}
    else
    return this.items[this.itemIndex];
  }*/
 /*
  get valueN(): number{
    if(this._value === '' || this._value === null)
      return 0
    else
      return Number(this._value);
    //return this._valueN;
  }*/
  readonly valueChange = output<string>();
  //@Output() valueNChange = new EventEmitter<number>();
  onValueChange() {
    // debugger;
    /* if(this.value !== newValue) FIXME: 有時候 會不斷 loop
      this.value = newValue; */
    if(this.valueChange)
      this.valueChange.emit(this._value);
  }
  constructor() {
    super();
   }
   override ngOnInit() {
    super.ngOnInit();
  }
  addWhere(where: string,fieldName:string,condition:string = '='): string {
    if(this.value){
      //where += ' AND ('+fieldName + ' = ' + jkLib.quotedStr(this.value)+') ';
      where = jkLib.text2Where(this.value, where, fieldName, condition);
    }
    return where;
  }

}
